// /protocols/:id — «Таблица протокола» (011, сценарии 2, 3 и 7): протокол в режиме ведения.
// Право на раздел — minutes.read (022: у внешнего оно есть по роли в протоколе без documents.read,
// research Р3); какие протоколы открываются и кто их правит, решает сервер по областям (FR-041,
// FR-042).
// Модуль таблицы (Tabulator, Tiptap) загружается только на этой странице (ADR-0035).
// 014 (T027; FR-004): ?item=<номер пункта> — переход из «Контроля» к пункту таблицы. Параметр
// читает страница таблицы (дорожка W4); чужое значение отбрасывается.
// 030 (T039; FR-023; ASG-DESK-06): ?assignee=<номер записи человека> — «Открыть в протоколе» из
// «Моих задач»: таблица открывается с быстрым фильтром «Ответственные» на этом человеке (вместе
// с переходом к item); после применения страница снимает оба параметра, как item.
// 0.26.1 (ACC-07): ?readiness=mailing — переход «Открыть рассылку П-N» из причины тени письма:
// окно «Готовность к рассылке» открывается на вкладке «Рассылка», если оно доступно; параметр
// снимается, как item.
import { IdSchema } from '@kp/contracts';
import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { requireSection } from '../../shell/permissions.ts';

const ProtocolPage = lazy(() =>
  import('../../features/minutes/ProtocolPage.tsx').then((module) => ({
    default: module.ProtocolPage,
  })),
);

interface ProtocolSearch {
  /** Пункт, к которому перейти в таблице. */
  item?: string | undefined;
  /** Запись человека справочника: начальный быстрый фильтр «Ответственные» (030). */
  assignee?: string | undefined;
  /** Окно готовности на вкладке «Рассылка» (0.26.1, ACC-07). */
  readiness?: 'mailing' | undefined;
}

/**
 * Чужое значение — undefined явно: корневой маршрут пропускает параметры адреса как есть, и без
 * этого непроверенный item дошёл бы до страницы в общем наборе параметров.
 */
function parseProtocolSearch(search: Record<string, unknown>): ProtocolSearch {
  const item = IdSchema.safeParse(search.item);
  const assignee = IdSchema.safeParse(search.assignee);
  return {
    item: item.success ? item.data : undefined,
    assignee: assignee.success ? assignee.data : undefined,
    readiness: search.readiness === 'mailing' ? 'mailing' : undefined,
  };
}

export const Route = createFileRoute('/_app/protocols/$id')({
  validateSearch: parseProtocolSearch,
  beforeLoad: requireSection('protocol'),
  staticData: { crumb: 'Таблица протокола' },
  component: ProtocolRoute,
});

function ProtocolRoute() {
  const { id } = Route.useParams();
  return (
    <Suspense fallback={null}>
      <ProtocolPage key={id} id={id} />
    </Suspense>
  );
}
